import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";

import { Grid } from "@mui/material";
import axios from "axios";
import { genURL, genURLTEST } from "../../_getjson";

import Conditionrecheck from "../../Components/ConditionSearch/Conditionrecheck";
import DateConvertByMoment from "../../CustomFunction/Date/DateconvertByMoment";

const from = "CSSALE";
const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "docdate",
    headerName: "วันที่เอกสาร",
    width: 150,
    editable: false,
  },
  {
    field: "docno",
    headerName: "เลขที่เอกสาร",
    width: 200,
    editable: false,
  },
  {
    field: "taxno",
    headerName: "ใบกำกับภาษี",
    width: 300,
    editable: false,
  },
  {
    field: "arcode",
    headerName: "รหัสลูกค้า",
    width: 110,
    editable: false,
    flex: 1,
  },
  {
    field: "arname",
    headerName: "ชื่อลูกค้า",
    width: 110,
    editable: false,
    flex: 1,
  },
  {
    field: "remark",
    headerName: "หมายเหตุ",
    width: 200,
    editable: false,
    flex: 1,
  },
];
export default function Rechecked(props) {
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const loadData = async (val, ConditionData, top) => {
    setopenbackdrop(true);
    // let url = ''
    // if (val === 'all') {
    // url = `CSPURCHASE/Search?top=100&startdate=${datestartdata != null ? datestartdata : ""}&enddate=${dateenddata != null ? dateenddata : ""}&startdocno=${docnostartdata != null ? docnostartdata : ""}&enddocno=${docnoenddata != null ? docnoenddata : ""}`
    // } else {
    let url = `CSSALES/SearchData?top=${top}&ConditionData=${ConditionData}`;
    // }
    console.log("ConditionData", ConditionData);
    //console.log(genURL(url))
    let rs = await axios.get(genURL(url));
    //  let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}`), { timeout: 12000 })
    let element = [];

    if (rs.data.length > 0) {
      console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          docdate: rs.data[index].DOCDATE,
          docno: rs.data[index].DOCNO,
          taxno: rs.data[index].TAXNO,
          arcode: rs.data[index].ARCODE,
          arname: rs.data[index].ARNAME,
          remark: rs.data[index].REMARK,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);
  };
  const resData = (e) => {
    // console.log("resData resData", e)
  };
  const removeresData = (e) => {
    //  console.log("resData removeresData", e)
  };
  const selcetRow = async (e) => {
    await props.Dataselect(e);
    // console.log("selcetRow", e)
  };
  const resDataConditions = async (e) => {
    console.log("resDataCondition", e[0].dateStart);

    // await setTop(e[3])

    let ConditionData = await JSON.stringify([
      {
        StartDate:
          e[0].dateStart === ""
            ? ""
            : e[0].dateStart === null
            ? ""
            : DateConvertByMoment(e[0].dateStart),
        EndDate:
          e[0].dateEnd === ""
            ? ""
            : e[0].dateEnd === null
            ? ""
            : DateConvertByMoment(e[0].dateEnd),

        StartDocNo: e[0].docNoStart,
        EndDocNo: e[0].docNoEnd,
        ArCode: e[0].arCode,
        SiteCode: e[0].siteCode,
        ArMainGroup: e[1].arMainGroup,
        ArtableData: JSON.stringify(e[1].tableData),
        ProductBrand: e[2].productBrand,
        ProductColor: e[2].productColor,
        ProductMainGroup: e[2].productMainGroup,
        ProductModel: e[2].productModel,
        ProductStatus: e[2].productStatus,
        ProductType: e[2].productType,
        ProductTableData: JSON.stringify(e[2].tableData),
        MachineNumber: e[0].machineNumber,
        ChassisNumber: e[0].chassisNumber,
      },
    ]);
    await loadData("all", ConditionData, e[3]);
  };
  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="xl">
        <Box sx={{ height: 500, width: "100%" }}>
          <Conditionrecheck
            resDataConditions={(e) => {
              resDataConditions(e);
            }}
            from={props.from}
          />
          {/* <Conditionrecheck resDataConditions={e => { resDataConditions(e) }} /> */}
          {rows.length > 0 ? (
            <CustomDataGrid
              datacolumns={columns}
              datarows={rows}
              rowHeight={38}
              Dataintable={(e) => resData(e)}
              Dataintableremove={(e) => removeresData(e)}
              startRow={1}
              option={[{ add: false, del: false, select: true }]}
              // checkboxSelection
              onRowClick={(e) => selcetRow([e.row])}
              // Dataselect={e => selcetRow(e)}

              RowsModelChange={(_) => console.log("RowsModelChange")}
              from={from}
            />
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign={"center"}>
                ไม่พบข้อมูล
              </Grid>
            </Grid>
          )}
          <CustomBackdrop open={openbackdrop} />
        </Box>
      </Container>
    </React.Fragment>
  );
}
